<template>
  <b-row>
    <b-col>
      <b-row>
        <!-- Datas -->
        <b-col md="4" sm="12">
          <b-form-group label="Data Inicial" label-for="from-date">
            <b-form-datepicker
              id="from-date"
              v-model="form.fromDate"
              placeholder="Selecione uma data"
              :date-format-options="{
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }"
              locale="pt-BR"
            />
          </b-form-group>
        </b-col>

        <b-col md="4" sm="12">
          <b-form-group label="Data Final" label-for="to-date">
            <b-form-datepicker
              id="to-date"
              v-model="form.toDate"
              placeholder="Selecione uma data"
              :date-format-options="{
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }"
              locale="pt-BR"
            />
          </b-form-group>
        </b-col>

        <!-- Botões -->
        <b-col md="4" sm="12" class="align-self-end">
          <div class="action-buttons">
            <b-button
              :variant="showStatus ? 'outline-primary' : 'outline-secondary'"
              @click="toggleStatus()"
            >
              <span class="fas fa-sliders-h mr-2" />
              Filtrar Status
              <b-badge v-if="selectedCount" variant="primary" pill class="ml-2">
                {{ selectedCount }}
              </b-badge>
            </b-button>

            <b-button variant="secondary" @click="handleClear">
              <span class="fas fa-times mr-2" />Limpar
            </b-button>

            <b-button variant="primary" @click="handleFilter">
              <span class="fas fa-filter mr-2" />Filtrar
            </b-button>
          </div>
        </b-col>

        <!-- Bloco Status -->
        <b-col v-if="showStatus" md="12" sm="12" class="mt-2">
          <b-form-group label="Status">
            <b-form-checkbox-group
              v-model="form.status"
              :options="statusOptions"
              switches
              class="status-grid"
            />
            <small class="text-muted d-block mt-1">
              Se nada for selecionado, todos os status serão incluídos.
            </small>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'RentsReportFilter',
  props: {
    value: {
      type: Object,
      default: () => ({ fromDate: null, toDate: null, status: [] })
    }
  },
  data() {
    return { showStatus: false }
  },
  computed: {
    form: {
      set(v) {
        this.$emit('input', v)
      },
      get() {
        return this.value
      }
    },
    statusOptions() {
      return [
        { value: 'active', text: 'Ativo' },
        { value: 'paused', text: 'Pausado' },
        { value: 'canceled', text: 'Cancelado' },
        { value: 'closed', text: 'Finalizado' },
        { value: 'rescued', text: 'Resgatado' }
      ]
    },
    selectedCount() {
      return Array.isArray(this.form.status) ? this.form.status.length : 0
    }
  },
  methods: {
    handleFilter() {
      this.$emit('filter')
    },
    handleClear() {
      this.form = { fromDate: null, toDate: null, status: [] }
      this.$emit('filter')
    },
    toggleStatus() {
      this.showStatus = !this.showStatus
    }
  }
}
</script>

<style scoped>
.status-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.25rem 0.75rem;
}

/* Alinhamento e espaçamento dos botões */
.action-buttons {
  display: flex;
  gap: 0.5rem;
}

/* Mobile: botões empilhados */
@media (max-width: 767.98px) {
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons .btn {
    width: 100%;
  }
}
</style>
